import type { Post, PostAuthor } from '../models/post';
import type { CardMediaLargeProps } from 'design-system/src/components/molecules/CardMediaLarge';
import { getImage, getSrc } from './media';

export function formatAuthor(
    author?: PostAuthor,
    {
        roleLabel,
        buttonLabel,
    }: { roleLabel?: string; buttonLabel?: string } = {},
) {
    return author?.name
        ? {
              name: author.name,
              image: getImage(author.image),
              previewImage: getImage(author.previewImage),
              href: !!author?.title ? author.href : null,
              role: author.role,
              ...(!!roleLabel && { roleLabel }),
              ...(!!buttonLabel && { buttonLabel }),
              bio: author?.bio,
              social:
                  [
                      author?.linkedin && {
                          label: 'linkedin',
                          href: author.linkedin,
                      },
                      author?.twitter && {
                          label: 'twitter',
                          href: author.twitter,
                      },
                  ].filter(Boolean) ?? [],
          }
        : null;
}

export function formatPost(
    post: Post,
    ctaLabel: string,
    large?: boolean,
): CardMediaLargeProps {
    const { href, media, largeMedia, topic, author, reviewer, ...rest } = post;

    return {
        ...rest,
        tag: topic?.label,
        media: getImage(large && largeMedia ? largeMedia : media),
        persons: [formatAuthor(author), formatAuthor(reviewer)].filter(
            Boolean,
        ) as any[],
        cta: {
            label: ctaLabel,
            href: href,
        },
    };
}

export function getImagesFromContentBlocks(blocks: any[]) {
    return (blocks || [])
        ?.map((record) => {
            if (record.typename === 'DatoCmsImageBlock') {
                return getSrc(record.image);
            }
            return null;
        })
        .filter(Boolean);
}

export function formatStructuredTextContent(content: any) {
    return {
        ...content,
        ...(!!content?.blocks?.length && {
            blocks: content.blocks.map((b: any) => {
                switch (b.typename) {
                    case 'DatoCmsCardBlock':
                        return {
                            ...b,
                            media: getImage(b.media),
                        };
                    case 'DatoCmsVideoBlock':
                        return {
                            ...b,
                            ...(!!b.video && {
                                video: {
                                    ...b.video,
                                    poster: getImage(b.video.thumbnailUrl),
                                },
                            }),
                        };
                    case 'DatoCmsImageBlock':
                        return {
                            ...b,
                            image: getImage(b.image),
                            target:
                                b.href && b.openInNewWindow ? '_blank' : null,
                        };
                    default:
                        return b;
                }
            }),
        }),
    };
}
